export default __webpack_public_path__ + "static/ROLVEDON-Logo-reg-37e60944a8fba88fd987ff37cd9495ae.png";